import { ImageState, ImageUploadStatus } from 'src/apps/NewDriverApp/redux/types/Types';

export const getIsImageUploadStarted = ({ uploadingStatus }: ImageState) =>
  [ImageUploadStatus.STARTED, ImageUploadStatus.SUCCESS].includes(
    uploadingStatus as ImageUploadStatus,
  );
